/** @format */

export default {
	SET_DEPOSIT: 'SET_DEPOSIT',
	SET_DEPOSITS: 'SET_DEPOSITS',
	SET_DEPOSITS_COUNT: 'SET_DEPOSITS_COUNT',
	SET_ERROR_FOR_DEPOSIT_QUERY: 'SET_ERROR_FOR_DEPOSIT_QUERY',
	SET_DEPOSITS_SUMMARY: 'SET_DEPOSITS_SUMMARY',
	SET_ERROR_FOR_DEPOSITS_SUMMARY: 'SET_ERROR_FOR_DEPOSITS_SUMMARY',
	SET_INSTANT_DEPOSIT: 'SET_INSTANT_DEPOSIT',
	SET_ALL_DEPOSITS_OVERVIEWS: 'SET_ALL_DEPOSITS_OVERVIEWS',
	SET_ERROR_FOR_ALL_DEPOSITS_OVERVIEWS:
		'SET_ERROR_FOR_ALL_DEPOSITS_OVERVIEWS',
};
